/**
 * Textos de la hoja «movimiento cuadrado» (B6 · H73), según el motivo de
 * `confirm-transaction-edit`. Claves inglesas; el español está en
 * `locale-overrides/es.json`.
 */
export type TextosCuadrado = {
  /** La acción borra (botón «Borrar») o solo cambia (botón «Guardar igual»). */
  borra: boolean;
  /** Varios movimientos a la vez. */
  varios: boolean;
  /** Afecta a una transferencia con la otra cuenta cuadrada. */
  transferencia: boolean;
  pregunta: string;
  detalle: string;
  accion: string;
};

export function textosCuadrado(motivo: string | undefined): TextosCuadrado {
  const borra =
    motivo === 'batchDeleteWithReconciledTransfer' ||
    motivo === 'batchDeleteWithReconciled' ||
    motivo === 'deleteReconciled';
  const varios = motivo?.startsWith('batch') ?? false;
  const transferencia = motivo?.endsWith('ReconciledTransfer') ?? false;
  const desbloquea = motivo === 'unlockReconciled';

  const pregunta = desbloquea
    ? 'Unlock this reconciled transaction?'
    : borra
      ? varios
        ? 'Delete these transactions?'
        : 'Delete this transaction?'
      : varios
        ? 'Change these transactions?'
        : 'Change this transaction?';

  const detalle = transferencia
    ? 'This transfer is already reconciled with the bank in the other account. If you change it, that balance may no longer match.'
    : desbloquea
      ? "This transaction is already reconciled with the bank. If you unlock it, we won't warn you before changing it."
      : 'This transaction is already reconciled with the bank. If you change it, the reconciled balance may no longer match.';

  const accion = borra ? 'Delete' : desbloquea ? 'Unlock' : 'Save anyway';

  return { borra, varios, transferencia, pregunta, detalle, accion };
}
